import React, { useEffect, useState } from 'react'
import { getFormCheck } from '../services/studentApi';
import { errorToast } from '../utils/errorHandling';
import { AiOutlineLoading } from 'react-icons/ai';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
// import '../styles/FormProgress.css';

const base_url = process.env.REACT_APP_BASE_URL;

const FormProgress = () => {
    const { t } = useTranslation();
    const [formcheck, setFormcheck] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const participant_id = JSON.parse(localStorage.getItem('participant_id'));

    const fetchFormCheck = async () => {
        setIsLoading(true);
        try {
            const formCheckData = await getFormCheck(participant_id);
            if (formCheckData) {
                setFormcheck(formCheckData);
            }
        } catch (error) {
            errorToast(error, t('general.ActionFailed'), t);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchFormCheck();
    }, []);

    return (

        <div className='form-wrapper m-0' >
            {isLoading ?
                <div className='d-flex justify-content-center'>
                    <AiOutlineLoading className='spin' />
                </div>
                :
                <>
                    <p className='text-center'><strong>
                        {t("Form.DisplayedAllForm")}
                        <span className='error'> {t("Form.FEB15")}</span></strong></p>
                    <div className="formcheck-table">
                        <table className="table formcheckTable" style={{ "maxWidth": "300px" }}>
                            <tbody>
                                <tr>
                                    <th><Link to={`${base_url}/view-personal-info`}>{t("Form.PersonalInfoForm")}</Link></th>
                                    <td>
                                        {formcheck.is_personal_info_filled === "1" ?
                                            <img src={`${base_url}/images/accept.png`} />
                                            :
                                            <img src={`${base_url}/images/cancel.png`} />
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <th><Link to={`${base_url}/passport-info`}>{t("Form.PassportForm")}</Link></th>
                                    <td>
                                        {formcheck.is_passport_filled === "1" ?
                                            <img src={`${base_url}/images/accept.png`} />
                                            :
                                            <img src={`${base_url}/images/cancel.png`} />
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <th><Link to={`${base_url}/view-accommodation`}>{t("Form.AccommodationForm")}</Link></th>
                                    <td>
                                        {formcheck.is_accommodation_filled === "1" ?
                                            <img src={`${base_url}/images/accept.png`} />
                                            :
                                            <img src={`${base_url}/images/cancel.png`} />
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <th><Link to={`${base_url}/health_declaration`}>{t("Form.HealthDeclarationForm")}</Link></th>
                                    <td>
                                        {formcheck.is_health_declaration_filled === "1" ?
                                            <img src={`${base_url}/images/accept.png`} />
                                            :
                                            <img src={`${base_url}/images/cancel.png`} />
                                        }
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <table className="table" style={{ "maxWidth": "300px" }}>
                            <tbody>
                                <tr>
                                    <th><Link to={`${base_url}/view-interview`}>{t("Form.InterviewForm")}</Link></th>
                                    <td>
                                        {formcheck.is_interview_filled === "1" ?
                                            <img src={`${base_url}/images/accept.png`} />
                                            :
                                            <img src={`${base_url}/images/cancel.png`} />
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <th><Link to={`${base_url}/view-interview`}>{t("Form.InterviewQuestionForm")}</Link></th>
                                    <td>
                                        {formcheck.is_interview_question_filled === "1" ?
                                            <img src={`${base_url}/images/accept.png`} />
                                            :
                                            <img src={`${base_url}/images/cancel.png`} />
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <th><Link to={`${base_url}/view-transportation`}>{t("Form.TransportationForm")}</Link></th>
                                    <td>
                                        {formcheck.is_transportation_filled === "1" ?
                                            <img src={`${base_url}/images/accept.png`} />
                                            :
                                            <img src={`${base_url}/images/cancel.png`} />
                                        }
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </>
            }

        </div>
    )
}

export default FormProgress